import React from 'react';
import './style.scss';
import { AnimatedHeading, HoverText } from '../../shared/TextFx';
import logo from './../../assets/footer-logo.svg';

/**
 * NOTE: the source markup for this footer still links to
 * `mvplogistics.eu` and reads "M.V.P. Trans-logistics" in the bottom
 * strip and copyright line — leftover placeholder branding from a
 * previous project this template was adapted from, not Esquire Express
 * content. Left in place for a faithful conversion; swap the `href`s and
 * copy below for the real site.
 */
 const MENU_COLUMNS = [
  {
    heading: 'About',
    headingHref: '#',
    items: [
      { label: 'Company', href: '#', dataService: 1 },
      { label: 'History', href: '#', dataService: 2 },
      { label: 'Success Stories', href: '#', dataService: 3 },
      { label: 'Testimonials', href: '#', dataService: 4 },
      { label: 'Memberships', href: '#', dataService: 5 },
      { label: 'Awards', href: '#', dataService: 6 },
      { label: 'Careers', href: '#', dataService: 6 },
      { label: 'Media', href: '#', dataService: 6 },
    ],
  },
  {
    heading: 'Services',
    headingHref: '#',
    items: [
      { label: 'On Board Courier (OBC)', href: '#', dataSection: '#our-story' },
      { label: 'Next Flight Out (NFO)', href: '#', dataSection: '#goals' },
      { label: 'Air Charters', href: '#', dataSection: '#advantages' },
      { label: 'Customs Brokerage', href: '#', dataSection: '#advantages' },
      { label: 'Surface Transportation', href: '#', dataSection: '#advantages' },
    ],
  },
  {
    heading: 'Industries',
    headingHref: '#',
    items: [
      { label: 'Aerospace', href: '#' },
      { label: 'Aviation', href: '#' },
      { label: 'Automotive', href: '#' },
      { label: 'Healthcare', href: '#' },
      { label: 'Pharmaceuticals', href: '#' },
      { label: 'Manufacturing', href: '#' },
      { label: 'Semiconductors', href: '#' },
      { label: 'Textiles & Garments', href: '#' },
      { label: 'Perishables', href: '#' },
      { label: 'Clinical Trials', href: '#' },
      { label: 'Sensitive Documents', href: '#' },
      { label: 'IT', href: '#' },
    ],
  },
  {
    heading: 'Quick Links',
    headingHref: '#',
    items: [
      { label: 'Tracking', href: '#', dataSection: '#info-contacts' },
      { label: 'Blogs', href: '#', dataSection: '#contact' },
      { label: 'Partner With Us', href: '#', dataSection: '#contact' },
      { label: 'Contact Us', href: '#', dataSection: '#contact' },
      { label: 'Clients', href: '#', dataSection: '#contact' },
    ],
  },
];

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer__container">
        <div className="footer__top">
          <a className="footer__logo" href="/">
            <img alt="Esquire Express" className="footer__logo-img" src={logo} />
          </a>

          <nav className="footer__menu">
            {MENU_COLUMNS.map((col) => (
              <div className="footer__menu-col" key={col.heading}>
                <a className="footer__menu-heading text-hover" href={col.headingHref}>
                  <HoverText words={col.heading} />
                </a>
                {col.items.map((item, index) => (
                  <a
                    className="footer__menu-item text-hover"
                    data-service={item.dataService}
                    href={item.href}
                    key={index}
                  >
                    <HoverText words={item.label} />
                  </a>
                ))}
              </div>
            ))}
          </nav>
        </div>

        <div className="footer__bottom">
          

          <div className="footer__bottom-container">
            <div className="footer__bottom-wrapper">
              <span className="footer__copyrights">2026 all rights reserved. Esquire Express</span>
              {/* <a className="footer__link text-hover" href="/privacy-policy">
                <HoverText words="Privacy Policy" />
              </a> */}
            </div>
            <div className="footer__bottom-wrap">
              <a
                className="footer__link text-hover _td-underline"
                href="#"
                rel="noreferrer"
                target="_blank"
              >
                <HoverText words="Website By: Tablonoir" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
